// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhj_a bhj_x bhj_j bhj_u bhj_bc bhj_qj bhj_vt"};